const PRIVACY_VALUES = {
  private: 'private',
  public: 'public'
}

Object.freeze(PRIVACY_VALUES)

export default PRIVACY_VALUES
